type ChevronProps = {
    color: string
}
export const ChevronLeft = ({color}:ChevronProps) => {
        return <svg  version="1.1" id="Layer_1" x="0px" y="0px" width={20} height={20}  viewBox="0 0 511.999 511.999" >
        <path style={{fill:color}} d="M172.548,256.005L388.82,39.729c9.089-9.089,9.089-23.824,0-32.912s-23.824-9.089-32.912,0.002  L123.18,239.551c-4.366,4.363-6.817,10.282-6.817,16.454c0,6.173,2.453,12.093,6.817,16.457l232.727,232.721  c4.543,4.544,10.499,6.816,16.455,6.816s11.913-2.271,16.457-6.817c9.089-9.089,9.089-23.824,0-32.912L172.548,256.005z"/>
        </svg>
}